/* global Intercom */
/* eslint-disable new-cap */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'found';
import withAuth from './Authenticate';
import {
  Button,
  Container,
  Divider,
  Icon,
  Item,
  Grid,
  Segment
} from 'semantic-ui-react';
import styles from './App.scss';
import MobileHeader from '../App/MobileHeader';
import { Analytics, AvailabilityChecker } from '../Modules';
import AcceptedPaymentMethods from './PaymentMethods/AcceptedPaymentMethods';
import AccountInfo from './AccountInfo';
import Playlists from './PlaylistsContainer';

const SettingsComponent = class SettingsComponent extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    viewer: PropTypes.object,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };

  componentDidMount() {
    Analytics.trackEvent('viewed-settings');
  }

  render() {
    const { relay, router, sidebarOpen, toggleSidebar, viewer } = this.props;
    return (
      <Container text className={styles.container}>
        <Segment>
          <MobileHeader viewer={viewer} router={router}>
            <div className='menu'>
              <Item
                as='a'
                className={sidebarOpen ? 'active ' : ''}
                onClick={toggleSidebar}
              >
                <Icon name='sidebar' />
              </Item>
            </div>
            <div className='right menu'>
              <AvailabilityChecker viewer={viewer} mobile />
              <Item as='a' onClick={router.push.bind(null, '/search')}>
                <Icon name='search' />
              </Item>
            </div>
          </MobileHeader>
          <Grid padded relaxed stackable>
            <Grid.Row>
              <Grid.Column>
                <h2 style={{ marginBottom: '2em' }}>Settings</h2>
                <Divider horizontal className={styles.settingsHeading}>
                  Accepted Payment Methods
                </Divider>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <AcceptedPaymentMethods viewer={viewer} relay={relay} />
              </Grid.Column>
            </Grid.Row>
            {viewer.features.music_lists && [
              <Grid.Row key='heading'>
                <Grid.Column>
                  <Divider horizontal className={styles.settingsHeading}>
                    Saved Playlists
                  </Divider>
                </Grid.Column>
              </Grid.Row>,
              <Grid.Row key='playlists'>
                <Grid.Column>
                  <Playlists viewer={viewer} relay={relay} />
                </Grid.Column>
              </Grid.Row>
            ]}
            <Grid.Row>
              <Grid.Column>
                <Divider horizontal className={styles.settingsHeading}>
                  User Profile and Billing
                </Divider>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <AccountInfo viewer={viewer} relay={relay} />
                <Button
                  basic
                  style={{ marginTop: '2em' }}
                  onClick={() =>
                    Intercom(
                      'showNewMessage',
                      'Hi, I would like to update my subscription.'
                    )}
                  content='Update or Cancel Subscription'
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
};

export default withRouter(withAuth(SettingsComponent));



// WEBPACK FOOTER //
// ./webpack/components/App/SettingsComponent.js